module.exports = __webpack_public_path__ + "ba16487aa84b63327be09017bb921d76.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/minus_19.svg
// module id = 1250
// module chunks = 74